import { service } from "../utils/service";
import { localPath } from "./api.js";

// 促销活动添加 (门店端-促销活动-促销活动添加)
export function addPromotion(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/add",
    method: "post",
    data: params
  });
}

// 促销活动审核 (门店端-促销活动-促销活动审核)
export function promotionAudit(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/audit",
    method: "post",
    data: params
  });
}
// 分页查询 门店端-促销活动-分页查询充值类别
export function promotionPage(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/page",
    method: "post",
    data: params
  });
}
// 分页查询 门店端-促销活动-首页
export function promotionList(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/selectList",
    method: "post",
    data: params
  });
}
// 促销活动推送 (门店端-促销活动-促销活动推送)
export function promotionPush(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/push",
    method: "post",
    data: params
  });
}
// 促销活动回收 (门店端-促销活动-促销活动回收)
export function promotionRevokeAudit(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/revokeAudit",
    method: "post",
    data: params
  });
}
// 促销活动关闭 (门店端-促销活动-促销活动关闭)
export function promotionShutDown(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/shutDown",
    method: "post",
    data: params
  });
}
// 促销活动送审 (门店端-促销活动-促销活动送审)
export function promotionSendAudit(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/sendAudit",
    method: "post",
    data: params
  });
}
// 退款单反审核 (门店端-退款单-退款单反审核)
export function promotionUnAudit(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/unAudit",
    method: "post",
    data: params
  });
}
// 促销活动修改 (门店端-促销活动-促销活动修改)
export function editPromotion(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/update",
    method: "post",
    data: params
  });
}

// 买就送添加疗程充值卡新接口
export function addCourseGitRechargePromotion(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/addCourseGitRechargePromotion",
    method: "post",
    data: params
  });
}

// 买就送查询赠送充值卡
export function rechargeList(params) {
  return service({
    url: "/api" + "/demay/ssm/promotionPro/rechargeList",
    method: "post",
    data: params
  });
}

// 买就送新修改接口
export function updatePromotionRechargeList(params) {
  return service({
    url: "/api" + "/demay/ssm/promotion/updatePromotionRechargeList",
    method: "post",
    data: params
  });
}

export function exportachis(params) {
  return service({
    url: "/api" + "/demay/ssm/baseZengka/exportachis",
    method: "post",
    data: params,
    responseType: "blob",
  });
}

// 分页查询 门店端-促销活动-分页查询促销活动指定会员数据
export function promotionMemPage(params) {
  return service({
    url: "/api" + "/demay/ssm/promotionMem/page",
    method: "post",
    data: params
  });
}
// 查询促销活动项目 门店端-促销活动-查询促销活动项目
export function promotionProList(params) {
  return service({
    url: "/api" + "/demay/ssm/promotionPro/list",
    method: "post",
    data: params
  });
}

// 查询促销活动项目 门店端-促销活动-查询促销活动项目
export function docPromotionProList(params) {
  return service({
    url: "/api" + "/demay/ssm/docPromotionPro/list",
    method: "post",
    data: params
  });
}
export function docPromotionProListNew(params) {
  return service({
    url: "/api" + "/demay/ssm/docPromotionPro/listNew",
    method: "post",
    data: params
  });
}

// 添加充值促销
export function recPromotionAdd(params) {
  return service({
    url: "/api" + "/demay/ssm/topUpPromotion/add",
    method: "post",
    data: params
  });
}
// 充值促销分页列表
export function recPromotionPage(params) {
  return service({
    url: "/api" + "/demay/ssm/topUpPromotion/page",
    method: "post",
    data: params
  });
}

// 添加赠卡申请单
export function addBaseZengka(params) {
  return service({
    url: "/api" + "/demay/ssm/baseZengka/add",
    method: "post",
    data: params
  });
}

// 修改赠卡申请单
export function editBaseZengka(params) {
  return service({
    url: "/api" + "/demay/ssm/baseZengka/update",
    method: "post",
    data: params
  });
}

// 赠卡导出
export function exportCard(params){
  return service({
    url:"/api" + '/demay/ssm/baseZengka/export',
    method: "post",
    data:params,
    responseType: "blob",
  })
}

// 赠卡page
export function baseZengkaPage(params) {
  return service({
    url: "/api" + "/demay/ssm/baseZengka/page",
    method: "post",
    data: params
  });
}
// 修改赠卡申请单状态
export function stateBaseZengka(params) {
  return service({
    url: "/api" + "/demay/ssm/baseZengka/updateState",
    method: "post",
    data: params
  });
}

// 添加团购卡申请单
export function addBaseGrouponCard(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponCard/add",
    method: "post",
    data: params,
    headers: {
      "Content-type": "application/x-www-form-urlencoded"
    }
  });
}

// 团购卡发送短信 
export function sendSms(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponCard/sendSms",
    method: "post",
    data: params
  });
}

// 修改团购卡申请单
export function editBaseGrouponCard(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponCard/update",
    method: "post",
    data: params,
    headers: {
      "Content-type": "application/x-www-form-urlencoded"
    }
  });
}
// 团购卡page
export function baseGrouponCardPage(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponCard/page",
    method: "post",
    data: params
  });
}
// 修改团购卡申请单状态
export function stateBaseGrouponCard(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponCard/updateState",
    method: "post",
    data: params
  });
}
// 导出团购卡
export function Export(params){
  return service({
    url:"/api" + '/demay/ssm/baseGrouponCard/export',
    method: "post",
    data: params,
    responseType: "blob",
  })
}
// 添加团购人名单
export function addBaseGrouponList(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponList/add",
    method: "post",
    data: params
  });
}

// 团购名单模板下载
export function downloadBaseGrouponList(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponList/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
//团购卡删除
export function delBaseGrouponCard(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponCard/delete",
    method: "post",
    data: params
  });
}
// 门店充值类别批量导入 门店端-充值类别列表-门店充值类别批量导入
export function importBaseGrouponList(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponList/import",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}

// 查询团购人名单(传团购单据Id)
export function selectBaseGrouponList(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponList/select",
    method: "post",
    data: params
  });
}

// 修改团购人名单
export function updateBaseGrouponList(params) {
  return service({
    url: "/api" + "/demay/ssm/baseGrouponList/update",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/promotion.js